import {Component,ElementRef,Input,OnInit,Output,ViewChild,EventEmitter,} from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { MultiSelectorDetails } from 'src/app/model/multi-selector-details';
import { messages } from 'src/app/resources/messages';
import { CatalogService } from 'src/app/services/catalog.service';

@Component({
  selector: 'rsp-dropdown',
  templateUrl: './rsp-dropdown.component.html',
  styleUrls: ['./rsp-dropdown.component.scss']
})
export class RspDropdownComponent implements OnInit {

  @Input() isOptional: boolean = true;
  @Input() displayLabel!: string;
  @Input() allowMultiSelect: boolean = true;
  @Input() selectorControlName!: AbstractControl<string>;
  @Input() submitted!: string;
  @Input() ariaText: string =
    'RSP Expandable List. Click or press enter to expand. Use arrow keys or tab to navigate through the list items and Esc key to close expanded list.';
  @Output() selectedValues = new EventEmitter<string[]>();

  @ViewChild('idMainBranchReference') rspCodeRef: ElementRef | undefined;

  public msg = messages;
  public rspCodeList: MultiSelectorDetails[] = [];
  public maxSelectionCount: number | undefined;
  public componentId!: string;
  constructor(private catalogService: CatalogService) { }

  ngOnInit(): void {
    this.setId();
    this.getRspData();
    this.setMaxlimit();
  }

  private getRspData() {
    this.catalogService.getRspCode().subscribe((response) => {
      this.rspCodeList = response.data.map(
        (x) => <MultiSelectorDetails>(<unknown>{
            id: x.mainBranchId,
            description: [x.mainBranchId, x.mainBranchIdName],
          })
      );
    });
  }

  public setSelectedRSPCode($event: any) {
    let rspCodes: string[] = $event.detail?.selectedItemArray.map(
      (x: MultiSelectorDetails) => x.id
    );
    this.selectedValues.emit(rspCodes);
    if (this.maxSelectionCount === 1) {
      this.rspCodeRef?.nativeElement.closeSelectionPanel();
    }
  }

  private setMaxlimit() {
    if (this.allowMultiSelect) {
      this.maxSelectionCount = undefined;
    } else {
      this.maxSelectionCount = 1;
    }
  }

  private setId() {
    if (!this.displayLabel) {
      this.componentId = 'rsp';
    } else {
      this.componentId = this.displayLabel.replace(' ', '-');
    }
  }

  public reset() {
    this.rspCodeRef?.nativeElement.resetSelectMenu();
  }

  public getAllRspCode(): string[] {
    let allRspCode = this.rspCodeList.map(
      (x: MultiSelectorDetails) => x.id!);
    return allRspCode;
  }

}
